module.exports = __webpack_public_path__ + "img/huace14.fe3c9be5.jpg";